import { createAsyncThunk } from '@reduxjs/toolkit';
import { useCustomAxios } from '../../shared/lib/customAxios';
import { API_ENDPOINTS } from '../../shared/constants/constants';

export const createQuoteApi = createAsyncThunk(
  'createQuote',
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();

    try {
      const response = await axiosPost(`${API_ENDPOINTS.createQuote}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const updateQuoteApi = createAsyncThunk(
  'updateQuote',
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();

    try {
      const response = await axiosPost(`${API_ENDPOINTS.updateQuote}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const getQuoteList = createAsyncThunk(
  'getQuoteList',
  async (parameter: any) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getQuoteList}`;

    Object.entries(parameter).forEach(
      ([key, value], index) =>
        (url = url + `${index > 0 ? '&' : '?'}${key}=${value}`)
    );

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const getQuoteDetails = createAsyncThunk(
  'getQuoteDetails',
  async (id: any, { dispatch }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getQuote}/${id}`;

    try {
      const response = await axiosGet(url);
      let quoteStatus;
      if (response.status === 200) {
        quoteStatus = await dispatch(getQuoteStatus(id)).unwrap();
      }
      return {
        data: { ...response.data, quoteData: quoteStatus?.data },
        status: response.status,
      };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const getQuoteStatus = createAsyncThunk(
  'getQuoteStatus',
  async (id: any) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getQuoteStatus}/${id}/statuses`;

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const uploadQuoteItemsFile = createAsyncThunk(
  'uploadQuoteItemsFile',
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(`${API_ENDPOINTS.fileUpload}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const downloadQuoteItemsExcel = createAsyncThunk(
  'downloadQuoteItemsExcel',
  async (rfqId: any) => {
    const { axiosGet } = useCustomAxios();
    try {
      let downloadURLAPIEndpoint = `${API_ENDPOINTS.downloadQUoteItemsExcel}`;
      // console.log("rfqId : " + rfqId);
      downloadURLAPIEndpoint = downloadURLAPIEndpoint.replace(":requestId", rfqId);
      const response = await axiosGet(downloadURLAPIEndpoint, { responseType: 'blob' });

      // console.log("response.data : ",response);
      const byteCharacters = atob(response.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Create a Blob object from the response data
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });


      // Create a temporary URL for the blob data
      const url = window.URL.createObjectURL(blob);

      // Trigger the download by creating an anchor element and simulating a click
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'example.xlsx');
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the temporary URL and anchor element
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error: any) {
      console.log('eror : ', error);
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);

export const getQuotesByRequestId = createAsyncThunk(
  'getQuotesByRequestId',
  async (parameter: any) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getQuotesByRequestId}`;
    // url = url.replace(":rfqId", parameter.rfqId);

    Object.entries(parameter).forEach(
      ([key, value], index) =>
        (url = url + `${index > 0 ? '&' : '?'}${key}=${value}`)
    );

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const getQuoteFile = createAsyncThunk(
  'getQuoteFile',
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(`${API_ENDPOINTS.getQuoteContent}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        status: error.response.status,
      };
    }
  }
);